import {
  BRACELL_DANO_SEVERIDADE,
} from "../config/bracellRegistryProfile";

function clampIntString(raw, min, max) {
  const n = Math.round(Number(String(raw).replace(",", ".")));
  if (!Number.isFinite(n)) return min;
  return Math.min(max, Math.max(min, n));
}

function normalizeDanoSeveridade(v) {
  const s = String(v || "").trim();
  if (BRACELL_DANO_SEVERIDADE.includes(s)) return s;
  return "Sem Dano";
}

/**
 * Transforma linhas do formulário BRACELL para o formato da API (paridade SF-APP).
 * @param {string} plagueType — 'beetle' | 'caterpillar' | 'psilide' | 'leptocybe'
 * @param {Array<object>} rows — amostras com extras BRACELL no estado interno
 */
export function buildBracellDadosPayload(plagueType, rows) {
  if (!Array.isArray(rows)) return [];

  return rows.map((row) => {
    const desfolha = clampIntString(
      row.desfolha_incidencia_percent ?? "0",
      0,
      100
    );
    const dano = normalizeDanoSeveridade(row.dano_severidade);

    const out = { ...row };

    delete out.desfolha_incidencia_percent;
    delete out.dano_severidade;

    out.desfolha_incidencia_percent = desfolha;
    out.dano_severidade = dano;

    if (plagueType === "beetle") {
      const insetos = clampIntString(row.percentualDesfolha ?? 0, 0, 999999);
      delete out.percentualDesfolha;
      out.numeroInsetos = insetos;
    }

    return out;
  });
}
